import $ from 'jquery';

export const simpleSelectInit = (id) => {
    const observer = new MutationObserver((mutationList) => {
        mutationList.forEach((mutation) => {
            if (mutation.attributeName !== 'aria-labelledby') {
                return;
            }

            const $select = $(mutation.target).parent().find('#' + id);

            if ($select.val() === $select.attr('data-prev-value')) {
                return;
            }

            $select.attr('data-prev-value', $select.val());
            $select.trigger('change');
        });
    });

    observer.observe(document.getElementById(id + '-button'), {
        attributes: true,
        attributeFilter: ['aria-labelledby']
    });

    window.addEventListener('beforeunload', () => {
        observer.disconnect();
    });
}
